import React, { useState, useEffect } from "react";

import {
  Container,
  Row,
  Col,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  Form,
  FormGroup,
  Label,
  CardBody,
  CardTitle,
  FormFeedback,
  Button,
  Table,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";

import classnames from "classnames";
import { getCountries, getGenders } from "../../helpers/dataBackend";
import { setAuthorization } from "../../helpers/api_helper";

//Import Breadcrumb
import Breadcrumbs from "../../Components/Common/Breadcrumb";

//Import Images
import avatar from "../../assets/images/users/avatar-1.jpg";
import { editProfile, fetchUsersInfo, sendDocumentEntity } from "slices/thunk";
import { RootState } from "slices";
import { PermissionWrapper } from "shared/permissionWrapper";
import Dropzone from "react-dropzone";
import { decryptState } from "shared/encryptInfo";
import { Link } from "react-router-dom";

const UserProfile = () => {
  //meta title
  document.title = "User Profile";

  const [activeTab, setActiveTab] = useState<any>("1");
  const [show, setShow] = useState(false);
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showNew2, setShowNew2] = useState(false);
  const [entityId, setEntityId] = useState<any>();
  const [documents, setDocuments] = useState<any>([]);
  const [errorWithFiles, setErrorWithFiles] = useState<any>(true);

  const dispatch = useDispatch<any>();

  const userRole = useSelector((state: RootState) => state.Login.roles);
  let showDocumentsSection;
  userRole.map((role: any) => {
    showDocumentsSection = role.name === "ENTITY_ROLE" ? true : false;
    return 0;
  });

  // ESTADOS DEL COMPONENTE
  const [countries, setCountries] = useState<any>([]);
  const [gendersType, setGendersType] = useState<any>([]);

  // SELECTOR REDUX
  const { user } = useSelector((state: RootState) => state.Profile);
  console.log("User Profile Data:", user);
  // -- --------------------------------------------
  // TODO - RELACIONADO A LA CARGA DE ARCHIVOS
  const [selectedFiles, setSelectedFiles] = useState<any[]>([]);

  //Archivos validos
  const handleAcceptedFiles = async (files: File[]) => {
    const filePromises = files.map(async (file) => {
      const base64 = await convertToBase64(file);
      return {
        file,
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
        base64, // Archivo convertido
      };
    });

    const fileData = await Promise.all(filePromises);
    setSelectedFiles((prevFiles) => [...prevFiles, ...fileData]);
  };

  //Tamano de los archivos
  const formatBytes = (bytes: number, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  //Convertir los archivos a base64
  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };

  //Quitar un archvio
  const removeFile = (index: number) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const submitInfo = (e: React.FormEvent) => {
    // Extraer solo los Base64 para enviar
    const filesToSend = selectedFiles.map((file) => ({
      entity_id: entityId,
      name: file.file.name,
      document_type: "Pruebas",
      document_base64: file.base64,
    }));

    // console.log({ documents: filesToSend });
    dispatch(sendDocumentEntity({ documents: filesToSend }));
    // fetch("/api/upload", { method: "POST", body: JSON.stringify(filesToSend) });
  };

  // ----------------------------------------------------------------
  // EFFECT QUE SE EJECUTA AL CARGAR EL COMPONONENTE
  useEffect(() => {
    async function getData() {
      const token = localStorage.getItem("authUser");
      setAuthorization(token); // Guardar el token antes de continuar
      const nose = localStorage.getItem("userInfo");
      const id_user = decryptState(nose || "{}");
      // console.log("User Info:", id_user.id);
      try {
        const countries = await getCountries();
        setCountries(JSON.parse(countries.data));
        const genders = await getGenders();
        setGendersType(JSON.parse(genders.data));
        dispatch(fetchUsersInfo(id_user.id));
      } catch (error) {
        console.log("Error fetching user data", error);
      }
    }
    getData();
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userInfo: any = localStorage.getItem("userInfo");
        const decriptedData = decryptState(userInfo);
        console.log("Decripted User Info:", decriptedData);
        setEntityId(decriptedData.entity_id);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  const validation: any = useFormik({
    initialValues: {
      name: user.name,
      last_name: user.last_name || "",
      email: user.email || "",
      phone_number: user.phone_number || "",
      document_number: user.document_number || "",
      address: user.address || "",
      gender_id: user.gender_id,
      country_id: user.country_id,
      date_of_birth: user.date_of_birth || "",
      user_pin: user.user_pin || "",
      idx: user.id || 1,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter your Name"),
      last_name: Yup.string().required("Please Enter your Last Name"),
      email: Yup.string().required("Please Enter your Email Address"),
      phone_number: Yup.string().required("Please Enter your Phone"),
      address: Yup.string().required("Please Enter your Address"),
      document_number: Yup.string().required(
        "Please Enter your Document number"
      ),
      country_id: Yup.number().required("Please Enter your Country"),
      gender_id: Yup.number().required("Please Enter your Gender"),
      date_of_birth: Yup.date().required("Please Enter your Date of birth"),
      user_pin: Yup.string().required("Please Enter your PIN"),
    }),
    onSubmit: (values: any) => {
      values.country_id = parseInt(values.country_id);
      values.gender_id = parseInt(values.gender_id);
      dispatch(editProfile(values));
    },
  });

  const validationPassword: any = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      newPasswordVerification: "",
      pin: 0,
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required(
        "Por favor, ingrese su contraseña actual"
      ),
      newPassword: Yup.string()
        .required("Por favor, ingrese una nueva contraseña")
        .min(8, "La contraseña debe tener al menos 8 caracteres")
        .matches(/[A-Z]/, "Debe contener al menos una letra mayúscula")
        .matches(/[a-z]/, "Debe contener al menos una letra minúscula")
        .matches(/[0-9]/, "Debe contener al menos un número")
        .matches(
          /[@$!%*?&]/,
          "Debe contener al menos un carácter especial (@, $, !, %, *, ?, &)"
        )
        .notOneOf(
          [Yup.ref("oldPassword")],
          "La nueva contraseña no puede ser igual a la anterior"
        ),
      newPasswordVerification: Yup.string()
        .required("Por favor, confirme su nueva contraseña")
        .oneOf([Yup.ref("newPassword")], "Las contraseñas no coinciden"),
      pin: Yup.number()
        .typeError("El PIN debe ser un número")
        .required("Por favor, ingrese un PIN"),
    }),
    onSubmit: (values: any) => {
      console.log(values);
      const newPasswordCreated = {
        password: values.newPassword,
      };
      dispatch(editProfile(newPasswordCreated));
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Profile" breadcrumbItem="Profile" />

          {/* BLOQUE PRINCIPAL INFO GENERAL */}
          <Row className="mb-3">
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="me-3">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{user.name || "admin"}</h5>
                        <p className="mb-1">
                          {user.email || "admin@admin.com"}
                        </p>
                        <p className="mb-0">Id no: #{user.id || 1}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <div className="checkout-tabs">
            <Row>
              <Col xl={2} sm={3}>
                <Nav className="flex-column" pills>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => {
                        setActiveTab("1");
                      }}
                    >
                      <i className="mdi mdi-account-box d-block check-nav-icon mt-4 mb-2" />
                      <p className="fw-bold mb-4">Accounts Detail</p>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => {
                        setActiveTab("2");
                      }}
                    >
                      <i className="mdi mdi-lock  d-block check-nav-icon mt-4 mb-2" />
                      <p className="fw-bold mb-4">Change Password</p>
                    </NavLink>
                  </NavItem>
                  {/* TODO / Ocultar este bloque */}
                  {showDocumentsSection ? (
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" })}
                        onClick={() => {
                          setActiveTab("3");
                        }}
                      >
                        <i className="bx bx-badge-check d-block check-nav-icon mt-4 mb-2" />
                        <p className="fw-bold mb-4">Entity Documents</p>
                      </NavLink>
                    </NavItem>
                  ) : null}
                </Nav>
              </Col>
              <Col xl={10} sm={9} className="mb-3">
                <Card>
                  <CardBody>
                    <TabContent activeTab={activeTab}>
                      {/* ----------------------------------- */}
                      {/* ACCOUNTS DETAILS */}
                      <TabPane tabId="1">
                        <div>
                          <CardTitle tag="h4">
                            Informacion de la Cuenta
                          </CardTitle>
                          <p className="card-title-desc">
                            Modifica tu información personal y mantén tus datos
                            siempre actualizados. Aquí puedes cambiar tu nombre,
                            apellidos, numero celular y otros detalles
                            importantes para mejorar tu experiencia en la
                            plataforma.
                          </p>
                          <hr />
                          <Form
                            onSubmit={(e) => {
                              e.preventDefault();
                              validation.handleSubmit();
                              return false;
                            }}
                          >
                            {/* NAME */}
                            <FormGroup className="mb-4" row>
                              <Label
                                htmlFor="name"
                                md="2"
                                className="col-form-label"
                              >
                                {" "}
                                Name
                              </Label>
                              <Col md={10}>
                                <Input
                                  name="name"
                                  className="form-control"
                                  placeholder="Enter Name"
                                  type="text"
                                  disabled
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.name || ""}
                                  invalid={
                                    validation.touched.name &&
                                    validation.errors.name
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.name &&
                                validation.errors.name ? (
                                  <FormFeedback type="invalid">
                                    {typeof validation.errors.name === "string"
                                      ? validation.errors.name
                                      : JSON.stringify(validation.errors.name)}
                                  </FormFeedback>
                                ) : null}
                              </Col>
                            </FormGroup>

                            {/* LAST NAME */}
                            <FormGroup className="mb-4" row>
                              <Label
                                htmlFor="last_name"
                                md="2"
                                className="col-form-label"
                              >
                                {" "}
                                Last Name
                              </Label>
                              <Col md={10}>
                                <Input
                                  name="last_name"
                                  className="form-control"
                                  placeholder="Enter Last name"
                                  type="text"
                                  disabled
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.last_name || ""}
                                  invalid={
                                    validation.touched.last_name &&
                                    validation.errors.last_name
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.last_name &&
                                validation.errors.last_name ? (
                                  <FormFeedback type="invalid">
                                    {typeof validation.errors.last_name ===
                                    "string"
                                      ? validation.errors.last_name
                                      : JSON.stringify(
                                          validation.errors.last_name
                                        )}
                                  </FormFeedback>
                                ) : null}
                              </Col>
                            </FormGroup>

                            {/* EMAIL */}
                            <FormGroup className="mb-4" row>
                              <Label
                                htmlFor="email"
                                md="2"
                                className="col-form-label"
                              >
                                Email Address{" "}
                              </Label>
                              <Col md={10}>
                                <Input
                                  name="email"
                                  className="form-control "
                                  placeholder="Enter Email"
                                  type="text"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.email || ""}
                                  disabled
                                  invalid={
                                    validation.touched.email &&
                                    validation.errors.email
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.email &&
                                validation.errors.email ? (
                                  <FormFeedback type="invalid">
                                    {typeof validation.errors.email === "string"
                                      ? validation.errors.email
                                      : JSON.stringify(validation.errors.email)}
                                  </FormFeedback>
                                ) : null}
                              </Col>
                            </FormGroup>

                            {/* DOCUMENT NUMBER */}
                            <FormGroup className="mb-4" row>
                              <Label
                                htmlFor="document_number"
                                md="2"
                                className="col-form-label"
                              >
                                Document Number{" "}
                              </Label>
                              <Col md={10}>
                                <Input
                                  name="document_number"
                                  className="form-control "
                                  placeholder="Enter Document Number"
                                  type="text"
                                  disabled
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={
                                    validation.values.document_number || ""
                                  }
                                  invalid={
                                    validation.touched.document_number &&
                                    validation.errors.document_number
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.document_number &&
                                validation.errors.document_number ? (
                                  <FormFeedback type="invalid">
                                    {typeof validation.errors
                                      .document_number === "string"
                                      ? validation.errors.document_number
                                      : JSON.stringify(
                                          validation.errors.document_number
                                        )}
                                  </FormFeedback>
                                ) : null}
                              </Col>
                            </FormGroup>

                            {/* PHONE NUMBER */}
                            <FormGroup className="mb-4" row>
                              <Label
                                htmlFor="phone_number"
                                md="2"
                                className="col-form-label"
                              >
                                Phone Number{" "}
                              </Label>
                              <Col md={10}>
                                <Input
                                  name="phone_number"
                                  className="form-control "
                                  placeholder="Enter Number"
                                  type="text"
                                  disabled
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.phone_number || ""}
                                  invalid={
                                    validation.touched.phone_number &&
                                    validation.errors.phone_number
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.phone_number &&
                                validation.errors.phone_number ? (
                                  <FormFeedback type="invalid">
                                    {typeof validation.errors.phone_number ===
                                    "string"
                                      ? validation.errors.phone_number
                                      : JSON.stringify(
                                          validation.errors.phone_number
                                        )}
                                  </FormFeedback>
                                ) : null}
                              </Col>
                            </FormGroup>

                            {/* ADDRESS */}
                            <FormGroup className="mb-4" row>
                              <Label
                                htmlFor="address"
                                md="2"
                                className="col-form-label"
                              >
                                Address
                              </Label>
                              <Col md={10}>
                                <Input
                                  tag="textarea"
                                  id="address"
                                  rows={3}
                                  placeholder="Enter full address"
                                  name="address"
                                  disabled
                                  value={validation.values.address}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  invalid={
                                    validation.touched.address &&
                                    validation.errors.address
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.address &&
                                validation.errors.address ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.address}
                                  </FormFeedback>
                                ) : null}
                              </Col>
                            </FormGroup>

                            {/* COUNTRY */}
                            <FormGroup className="select2-container mb-4" row>
                              <Label md={2} className="col-form-label">
                                Country
                              </Label>
                              <Col md={10}>
                                <Input
                                  type="select"
                                  name="country_id"
                                  disabled
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.country_id || ""}
                                  invalid={
                                    validation.touched.country_id &&
                                    validation.errors.country_id
                                      ? true
                                      : false
                                  }
                                >
                                  <option value="" selected disabled>
                                    Select country
                                  </option>
                                  {countries.map((country: any) => (
                                    <option key={country.id} value={country.id}>
                                      {country.name}
                                    </option>
                                  ))}
                                </Input>
                                {validation.touched.country_id &&
                                  validation.errors.country_id && (
                                    <FormFeedback>
                                      {validation.errors.country_id}
                                    </FormFeedback>
                                  )}
                              </Col>
                            </FormGroup>

                            {/* GENDER */}
                            <FormGroup className="select2-container mb-4" row>
                              <Label md={2} className="col-form-label">
                                Gender
                              </Label>
                              <Col md={10}>
                                <Input
                                  type="select"
                                  name="gender_id"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.gender_id || ""}
                                  disabled
                                  invalid={
                                    validation.touched.gender_id &&
                                    validation.errors.gender_id
                                      ? true
                                      : false
                                  }
                                >
                                  <option value="" selected disabled>
                                    Select gender
                                  </option>
                                  {gendersType.map((gender) => (
                                    <option key={gender.id} value={gender.id}>
                                      {gender.name}
                                    </option>
                                  ))}
                                </Input>
                                {validation.touched.gender_id &&
                                  validation.errors.gender_id && (
                                    <FormFeedback>
                                      {validation.errors.gender_id}
                                    </FormFeedback>
                                  )}
                              </Col>
                            </FormGroup>

                            {/* DATE OF BIRTH */}
                            <FormGroup className="mb-4" row>
                              <Label
                                htmlFor="date_of_birth"
                                md="2"
                                className="col-form-label"
                              >
                                {" "}
                                Date of birth
                              </Label>
                              <Col md={10}>
                                <Input
                                  name="date_of_birth"
                                  className="form-control"
                                  placeholder="Enter Date of birth"
                                  type={user.date_of_birth ? "text" : "date"}
                                  disabled
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.date_of_birth || ""}
                                  invalid={
                                    validation.touched.date_of_birth &&
                                    validation.errors.date_of_birth
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.date_of_birth &&
                                validation.errors.date_of_birth ? (
                                  <FormFeedback type="invalid">
                                    {typeof validation.errors.date_of_birth ===
                                    "string"
                                      ? validation.errors.date_of_birth
                                      : JSON.stringify(
                                          validation.errors.date_of_birth
                                        )}
                                  </FormFeedback>
                                ) : null}
                              </Col>
                            </FormGroup>

                            {/* PIN */}
                            <FormGroup className="mb-4" row>
                              <Label
                                htmlFor="user_pin"
                                md="2"
                                className="col-form-label"
                              >
                                User PIN{" "}
                              </Label>
                              <Col md={10}>
                                <div className="input-group auth-pass-inputgroup">
                                  <Input
                                    name="user_pin"
                                    className="form-control "
                                    placeholder="Enter pin"
                                    type={show ? "text" : "password"}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.user_pin || ""}
                                    invalid={
                                      validation.touched.user_pin &&
                                      validation.errors.user_pin
                                        ? true
                                        : false
                                    }
                                  />
                                  <button
                                    onClick={() => setShow(!show)}
                                    className="btn btn-light "
                                    type="button"
                                    id="password-addon"
                                  >
                                    <i className="mdi mdi-eye-outline"></i>
                                  </button>
                                </div>
                                {validation.touched.user_pin &&
                                validation.errors.user_pin ? (
                                  <FormFeedback type="invalid">
                                    {typeof validation.errors.user_pin ===
                                    "string"
                                      ? validation.errors.user_pin
                                      : JSON.stringify(
                                          validation.errors.user_pin
                                        )}
                                  </FormFeedback>
                                ) : null}
                              </Col>
                            </FormGroup>

                            <div className="text-center mt-4">
                              {" "}
                              <PermissionWrapper action={"US0007"}>
                                <Button type="submit" color="success" disabled>
                                  Update User Information{" "}
                                </Button>{" "}
                              </PermissionWrapper>
                            </div>
                          </Form>
                        </div>
                      </TabPane>

                      {/* ------------------------- */}
                      {/* CHANGE PASSWORD */}
                      <TabPane
                        tabId="2"
                        id="v-pills-payment"
                        role="tabpanel"
                        aria-labelledby="v-pills-payment-tab"
                      >
                        <div>
                          <CardTitle>Cambiar la contraseña</CardTitle>
                          <p className="card-title-desc">
                            En esta pagina podras cambiar la contraseña
                          </p>

                          <div className="p-4 border">
                            <Form
                              onSubmit={(e) => {
                                e.preventDefault();
                                validationPassword.handleSubmit();
                                return false;
                              }}
                            >
                              <div className="form-group mb-3 d-flex">
                                <Label
                                  htmlFor="oldPassword"
                                  style={{ width: 300 + "px" }}
                                >
                                  Contraseña vieja{" "}
                                </Label>
                                <div className="input-group auth-pass-inputgroup">
                                  <Input
                                    name="oldPassword"
                                    value={
                                      validationPassword.values.oldPassword ||
                                      ""
                                    }
                                    type={showOld ? "text" : "password"}
                                    placeholder="Enter Password"
                                    onChange={validationPassword.handleChange}
                                    onBlur={validationPassword.handleBlur}
                                    invalid={
                                      validationPassword.touched.oldPassword &&
                                      validationPassword.errors.oldPassword
                                        ? true
                                        : false
                                    }
                                  />
                                  <button
                                    onClick={() => setShowOld(!showOld)}
                                    className="btn btn-light "
                                    type="button"
                                    id="password-old"
                                  >
                                    <i className="mdi mdi-eye-outline"></i>
                                  </button>
                                  {validationPassword.touched.oldPassword &&
                                  validationPassword.errors.oldPassword ? (
                                    <FormFeedback type="invalid">
                                      {typeof validationPassword.errors
                                        .oldPassword === "string"
                                        ? validationPassword.errors.oldPassword
                                        : JSON.stringify(
                                            validationPassword.errors
                                              .oldPassword
                                          )}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </div>

                              <div className="form-group mb-3 d-flex">
                                <Label
                                  htmlFor="newPassword"
                                  style={{ width: 300 + "px" }}
                                >
                                  Nueva Contraseña{" "}
                                </Label>
                                <div className="input-group auth-pass-inputgroup">
                                  <Input
                                    name="newPassword"
                                    value={
                                      validationPassword.values.newPassword ||
                                      ""
                                    }
                                    type={showNew ? "text" : "password"}
                                    placeholder="Enter Password"
                                    onChange={validationPassword.handleChange}
                                    onBlur={validationPassword.handleBlur}
                                    invalid={
                                      validationPassword.touched.newPassword &&
                                      validationPassword.errors.newPassword
                                        ? true
                                        : false
                                    }
                                  />
                                  <button
                                    onClick={() => setShowNew(!showNew)}
                                    className="btn btn-light "
                                    type="button"
                                    id="password-new"
                                  >
                                    <i className="mdi mdi-eye-outline"></i>
                                  </button>
                                  {validationPassword.touched.newPassword &&
                                  validationPassword.errors.newPassword ? (
                                    <FormFeedback type="invalid">
                                      {typeof validationPassword.errors
                                        .newPassword === "string"
                                        ? validationPassword.errors.newPassword
                                        : JSON.stringify(
                                            validationPassword.errors
                                              .newPassword
                                          )}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </div>
                              <div className="form-group mb-3 d-flex">
                                <Label
                                  htmlFor="newPasswordVerification"
                                  style={{ width: 300 + "px" }}
                                >
                                  Repita nuevamente la contraseña{" "}
                                </Label>
                                <div className="input-group auth-pass-inputgroup">
                                  <Input
                                    name="newPasswordVerification"
                                    value={
                                      validationPassword.values
                                        .newPasswordVerification || ""
                                    }
                                    type={showNew2 ? "text" : "password"}
                                    placeholder="Enter Password"
                                    onChange={validationPassword.handleChange}
                                    onBlur={validationPassword.handleBlur}
                                    invalid={
                                      validationPassword.touched
                                        .newPasswordVerification &&
                                      validationPassword.errors
                                        .newPasswordVerification
                                        ? true
                                        : false
                                    }
                                  />
                                  <button
                                    onClick={() => setShowNew2(!showNew2)}
                                    className="btn btn-light "
                                    type="button"
                                    id="password-newnew"
                                  >
                                    <i className="mdi mdi-eye-outline"></i>
                                  </button>
                                  {validationPassword.touched
                                    .newPasswordVerification &&
                                  validationPassword.errors
                                    .newPasswordVerification ? (
                                    <FormFeedback type="invalid">
                                      {typeof validationPassword.errors
                                        .newPasswordVerification === "string"
                                        ? validationPassword.errors
                                            .newPasswordVerification
                                        : JSON.stringify(
                                            validationPassword.errors
                                              .newPasswordVerification
                                          )}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </div>
                              <div className="d-flex justify-content-end align-items-end gap-3">
                                <div className="form-group mt-4 mb-0">
                                  <Label htmlFor="pin">PIN </Label>
                                  <Input
                                    name="pin"
                                    value={validationPassword.values.pin || ""}
                                    type="password"
                                    placeholder="Enter Password"
                                    onChange={validationPassword.handleChange}
                                    onBlur={validationPassword.handleBlur}
                                    invalid={
                                      validationPassword.touched.pin &&
                                      validationPassword.errors.pin
                                        ? true
                                        : false
                                    }
                                  />
                                </div>

                                <div className="text-center mt-4">
                                  {" "}
                                  <PermissionWrapper action={"US0009"}>
                                    <Button type="submit" color="success">
                                      Update Password{" "}
                                    </Button>{" "}
                                  </PermissionWrapper>
                                </div>
                              </div>
                            </Form>
                          </div>
                        </div>
                      </TabPane>

                      {/* ------------------------------- */}
                      {/* MORE INFORMATION */}
                      <TabPane tabId="3" id="v-pills-confir" role="tabpanel">
                        <Card className="shadow-none border mb-0">
                          <CardBody>
                            <CardTitle className="">
                              {" "}
                              Entity Documents
                            </CardTitle>

                            <div className="table-responsive">
                              <Card>
                                <CardBody>
                                  <CardTitle className="mb-4">
                                    Attached Files
                                  </CardTitle>
                                  <div className="table-responsive">
                                    <Table className="table-nowrap align-middle table-hover mb-0">
                                      <tbody>
                                        {(documents || [])?.map(
                                          (file: any, i: number) => (
                                            <tr key={"_file_" + i}>
                                              <td style={{ width: "45px" }}>
                                                <div className="avatar-sm">
                                                  <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-24">
                                                    <i className="bx bxs-file-doc" />
                                                  </span>
                                                </div>
                                              </td>
                                              <td>
                                                <h5 className="font-size-14 mb-1">
                                                  <Link
                                                    to="#"
                                                    className="text-dark"
                                                  >
                                                    {file.name}
                                                  </Link>
                                                </h5>
                                                <small>
                                                  Size : {file.size}
                                                </small>
                                              </td>
                                              <td>
                                                <div className="d-flex text-center justify-content-between">
                                                  {errorWithFiles ? (
                                                    <button
                                                      type="button"
                                                      className="btn btn-danger "
                                                    >
                                                      <i className="bx bx-block font-size-16 align-middle me-2"></i>{" "}
                                                      Danger
                                                    </button>
                                                  ) : null}
                                                  <a
                                                    href={file.document_base64}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-dark"
                                                  >
                                                    <i className="bx bx-download h3 m-0" />
                                                  </a>
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </Table>
                                  </div>
                                </CardBody>
                              </Card>
                              <Card>
                                <CardBody>
                                  <div>
                                    <h6 className="card-title">Dropzone</h6>
                                    <div className="mb-4">
                                      {" "}
                                      DropzoneJS is an open source library that
                                      provides drag’n’drop file uploads with
                                      image previews.
                                    </div>
                                    <Form
                                      onSubmit={(e) => {
                                        e.preventDefault();
                                        submitInfo(e);
                                        return false;
                                      }}
                                    >
                                      <div style={{ width: "500px" }}>
                                        <Dropzone
                                          onDrop={(acceptedFiles) =>
                                            handleAcceptedFiles(acceptedFiles)
                                          }
                                        >
                                          {({
                                            getRootProps,
                                            getInputProps,
                                          }) => (
                                            <div className="dropzone">
                                              <div
                                                className="dz-message needsclick mt-2"
                                                {...getRootProps()}
                                              >
                                                <input {...getInputProps()} />
                                                <div className="mb-3">
                                                  <i className="display-4 text-muted bx bxs-cloud-upload" />
                                                </div>
                                                <h4>
                                                  Arrastra los archivos aquí o
                                                  haz clic para subir.
                                                </h4>
                                              </div>
                                            </div>
                                          )}
                                        </Dropzone>
                                      </div>

                                      <div className="dropzone-previews mt-3">
                                        {selectedFiles.map((file, index) => (
                                          <Card
                                            key={index}
                                            className="mt-1 mb-0 shadow-none border"
                                          >
                                            <div className="p-2 d-flex justify-content-between align-items-center">
                                              <Row className="align-items-center">
                                                <Col className="col-auto">
                                                  <img
                                                    height="80"
                                                    className="avatar-sm rounded bg-light"
                                                    alt={file.file.name}
                                                    src={file.preview}
                                                  />
                                                </Col>
                                                <Col>
                                                  <strong className="text-muted">
                                                    {file.file.name}
                                                  </strong>
                                                  <p className="mb-0">
                                                    <strong>
                                                      {file.formattedSize}
                                                    </strong>
                                                  </p>
                                                </Col>
                                              </Row>
                                              <button
                                                type="button"
                                                onClick={() =>
                                                  removeFile(index)
                                                }
                                                className="btn btn-danger  w-sm"
                                              >
                                                <i className="mdi mdi-trash-can d-block font-size-16"></i>{" "}
                                                Delete
                                              </button>
                                            </div>
                                          </Card>
                                        ))}
                                      </div>

                                      <div className="text- mt-4">
                                        <button
                                          type="submit"
                                          className="btn btn-primary"
                                          disabled={selectedFiles.length <= 0}
                                        >
                                          Enviar Archivos
                                        </button>
                                      </div>
                                    </Form>
                                  </div>
                                </CardBody>
                              </Card>
                            </div>
                          </CardBody>
                        </Card>
                      </TabPane>
                      {/* ----------------------- */}
                    </TabContent>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserProfile;
